import React from "react";
import { formatText } from "../../utils/formatters";

// (2026-05-15) Rediseño Sirius. Antes el modal usaba el patrón viejo
// (panel w-[75%] h-[90%] + lista <p><strong>) y footer .absolute.bottom-4.
// Reescrito al patrón estándar (overlay → panel redondeado → header /
// body scroll / footer en flujo) con los datos en tarjetas `Item`.
// Toda la lógica/bindings de `product` se conserva idéntica, incluido el
// gating admin/auditor de la Afiliada y la cadena emisor→tercero.
function ModalProducts({ isOpen, onClose, product }) {
  if (!isOpen || !product) return null;

  // (2026-05-13) Misma logica de gating que en ListProducts: solo admin/auditor
  // ven el RIF + Empresa (Afiliada) del cliente propietario del producto.
  const authData = localStorage.getItem("authData");
  const rolActual = authData ? JSON.parse(authData)["rol"] : "";
  const puedeVerAfiliada = rolActual === "admin" || rolActual === "auditor";

  const Item = ({ label, children, full }) => (
    <div className={full ? "w-full" : "w-full sm:w-1/2 lg:w-1/3"}>
      <div className="bg-slate-50/70 rounded-xl border border-slate-200/70 p-4 h-full">
        <h3 className="text-[11px] uppercase tracking-[0.12em] font-semibold text-ink-500 mb-1.5">{label}</h3>
        <div className="text-sm font-medium text-ink-900 break-words">{children}</div>
      </div>
    </div>
  );

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-black/50">
      <div className="bg-white rounded-2xl shadow-sirius-lg w-full max-w-[1100px] max-h-[90vh] flex flex-col overflow-hidden">
        {/* HEADER */}
        <div className="px-6 md:px-8 py-5 border-b border-slate-200 bg-white">
          <h6 className="text-lg md:text-xl font-display font-bold text-ink-900 text-center">
            Detalles del Producto/Servicio
          </h6>
        </div>

        {/* BODY */}
        <div className="flex-1 min-h-0 overflow-y-auto px-6 md:px-8 py-6">
          <div className="flex flex-wrap gap-3">
            <Item label="SKU">{formatText(product.sku) || "—"}</Item>
            <Item label="Nombre">{formatText(product.nombre) || "—"}</Item>
            <Item label="Precio Base">{product.precio_base ?? "—"}</Item>
            <Item label="Activo">
              {product.activo ? (
                <span className="inline-block bg-emerald-500 text-white py-1 px-3 rounded-full text-xs font-bold">SÍ</span>
              ) : (
                <span className="inline-block bg-rose-500 text-white py-1 px-3 rounded-full text-xs font-bold">NO</span>
              )}
            </Item>
            <Item label="IVA">
              {product.iva_categoria ? `${product.iva_categoria.nombre}` : "N/A"}
            </Item>
            <Item label="Peso (Kg)">{product.peso_kg ?? "—"}</Item>
            <Item label="Volumen (M³)">{product.volumen_m3 ?? "—"}</Item>
            <Item label="Producto de comisión (tercero)">
              {product.es_tercero ? (
                <span className="inline-block bg-amber-100 text-amber-700 py-1 px-3 rounded-full text-xs font-bold">SI</span>
              ) : (
                <span className="inline-block bg-slate-200 text-ink-700 py-1 px-3 rounded-full text-xs font-bold">NO</span>
              )}
            </Item>
            <Item label="Descripción" full>{product.descripcion || "N/A"}</Item>
          </div>

          {/* (2026-05-13) Afiliada — visible para admin/auditor. Si el cliente
              propietario es TERCERO, se muestra además el emisor padre. */}
          {puedeVerAfiliada && (
            <>
              <h3 className="text-[11px] uppercase tracking-[0.12em] font-semibold text-ink-400 mt-7 mb-3">
                Afiliada {product.empresa && product.empresa.es_tercero ? "(Tercero)" : ""}
              </h3>
              <div className="flex flex-wrap gap-3">
                <Item label="RIF (Afiliada)">
                  {product.empresa && product.empresa.rif ? formatText(product.empresa.rif) : "—"}
                </Item>
                <Item label="Empresa (Afiliada)">
                  {product.empresa && product.empresa.nombre_empresa
                    ? formatText(product.empresa.nombre_empresa)
                    : "—"}
                </Item>
              </div>

              {/* (2026-05-14) Cadena emisor -> tercero cuando aplica. */}
              {product.empresa && product.empresa.es_tercero && product.empresa_padre && (
                <>
                  <h3 className="text-[11px] uppercase tracking-[0.12em] font-semibold text-ink-400 mt-7 mb-3">
                    Emisor (Padre)
                  </h3>
                  <div className="flex flex-wrap gap-3">
                    <Item label="RIF (Emisor)">
                      {product.empresa_padre.rif ? formatText(product.empresa_padre.rif) : "—"}
                    </Item>
                    <Item label="Empresa (Emisor)">
                      {product.empresa_padre.nombre_empresa
                        ? formatText(product.empresa_padre.nombre_empresa)
                        : "—"}
                    </Item>
                  </div>
                </>
              )}
            </>
          )}
        </div>

        {/* FOOTER */}
        <div className="shrink-0 w-full flex justify-center py-4 border-t border-slate-200 bg-white">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-twilight-indigo-600 hover:bg-twilight-indigo-500 text-white font-semibold rounded-xl transition"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalProducts;
